(() => {
  if (window.TECartLook) return;
  window.TECartLook = true;

  const root = window.Shopify?.routes?.root || '/';
  const groups = () => Array.from(document.querySelectorAll('[data-te-cart-look]'));
  const audience = () => {
    const path = location.pathname.toLowerCase();
    if (/\/collections\/femme(?:\/|$)/.test(path)) return 'femme';
    if (/\/collections\/homme(?:\/|$)/.test(path)) return 'homme';
    try { return sessionStorage.getItem('te-shopping-audience') || 'default'; } catch (_) { return 'default'; }
  };
  const rememberAudience = () => {
    const path = location.pathname.toLowerCase();
    try {
      if (/\/collections\/femme(?:\/|$)/.test(path)) sessionStorage.setItem('te-shopping-audience', 'femme');
      if (/\/collections\/homme(?:\/|$)/.test(path)) sessionStorage.setItem('te-shopping-audience', 'homme');
    } catch (_) {}
  };

  async function refresh() {
    const all = groups();
    if (!all.length) return;
    let cart;
    try {
      const response = await fetch(root + 'cart.js', { headers: { Accept: 'application/json' } });
      if (!response.ok) return;
      cart = await response.json();
    } catch (_) { return; }
    all.forEach(group => { group.hidden = true; });

    const ids = new Set((cart.items || []).map(item => String(item.product_id)));
    const matching = cart.items?.length
      ? all.find(group => group.dataset.triggerProducts.split(',').some(id => ids.has(id)))
      : null;
    const group = matching || all.find(item => !item.dataset.triggerProducts);
    if (!group) return;
    const chosenAudience = audience();
    let list = group.querySelector(`[data-te-audience="${chosenAudience}"]`);
    if (!list?.children.length) list = group.querySelector('[data-te-audience="default"]');
    group.querySelectorAll('[data-te-audience]').forEach(item => { item.hidden = item !== list; });
    if (!list) return;
    let shown = 0;
    const limit = Number(group.dataset.limit) || 2;
    list.querySelectorAll('[data-product-id]').forEach(item => {
      const visible = !ids.has(item.dataset.productId) && shown < limit;
      item.hidden = !visible;
      if (visible) shown += 1;
    });
    group.hidden = shown === 0;
  }

  document.addEventListener('change', event => {
    const variant = event.target.closest('[data-te-cart-look] [data-te-variant]');
    if (!variant || variant.tagName !== 'SELECT') return;
    const price = variant.closest('.te-cart-look__item').querySelector('[data-te-price]');
    if (price) price.textContent = variant.selectedOptions[0]?.dataset.price || price.textContent;
  });

  document.addEventListener('click', async event => {
    const button = event.target.closest('[data-te-cart-look] [data-te-add]');
    if (!button || button.disabled) return;
    const item = button.closest('.te-cart-look__item');
    const variantId = item.querySelector('[data-te-variant]')?.value;
    const error = item.querySelector('[data-te-error]');
    if (!variantId) {
      error.textContent = 'Choisissez d’abord une taille ou une variante.';
      error.hidden = false;
      item.querySelector('[data-te-variant]')?.focus();
      return;
    }
    button.disabled = true;
    error.hidden = true;
    try {
      const response = await fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] })
      });
      if (!response.ok) {
        const result = await response.json();
        throw new Error(result.description || 'Cette taille n’est plus disponible.');
      }
      if (/\/cart\/?$/.test(location.pathname)) {
        location.reload();
        return;
      }
      document.dispatchEvent(new CustomEvent('theme:cart:refresh', { bubbles: true }));
    } catch (reason) {
      error.textContent = reason.message || 'Ajout impossible pour le moment.';
      error.hidden = false;
    } finally {
      button.disabled = false;
    }
  });

  rememberAudience();
  document.addEventListener('theme:cart:refresh', refresh);
  document.addEventListener('theme:cart:added', refresh);
  document.addEventListener('theme:cart:loaded', refresh);
  document.addEventListener('shopify:section:load', refresh);
  document.addEventListener('shopify:section:select', refresh);
  refresh();
})();
